import tripEvents from './../config/events.constant';

import template from './templates/childTraveller.tmpl.html';
import templateTripDetails from './templates/tripDetails/childTraveller.tmpl.html';

const DIRECTIVE_NAME = 'childTraveller';

export default function ChildTraveller() {
    return {
        restrict: 'A',
        template: function(el, attr) {
            return attr.template ? templateTripDetails : template;
        },
        scope: {
            child: '=',
            model: '=',
            index: '=',
            lists: '=',
            send: '&',
            isLocked: '=',
            isDisable: '=',
            isCancelled: '=',
            wasConfirmed: '=',
            sendDocumentation: '=',
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
        },
        controller: ChildTravellerController,
        controllerAs: '$ctrl',
        link: ($scope, $elem, $attr, $ctrl) => $ctrl.$onInit(),
    };
}
export function ChildTravellerController(
    $scope,
    $rootScope,
    $state,
    tripFactory,
    travellerUtils,
    deviceDetector,
    userService,
    l10nService
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        isEditIconEnabled,
        handleEditClick,
        handleMailClick,
        isMailIconEnabled,
        isSendDocumentationOptionVisible,
        l10nService,
    });

    function $onInit() {
        initScope($scope);
    }
    function isEditIconEnabled() {
        return travellerUtils.isEditIconEnabled(
            $scope.isLocked,
            $scope.isDisable,
            $scope.isCancelled,
            $scope.model
        );
    }
    function handleEditClick() {
        if (vm.isEditIconEnabled()) {
            return $scope.edit();
        }
    }
    function handleMailClick() {
        if (!$scope.model.IsOfflineTrip) {
            return $scope.sendTripToReview();
        }
    }

    function isMailIconEnabled() {
        return !($scope.isSendTripToReviewDisabled()
            || $scope.model.IsOfflineTrip);
    }

    function initScope(scope) {
        scope.l10n = l10nService;
        scope.regionalSettings = userService.getRegionalSettings();

        scope.sendTripToReview = function() {
            if (!(scope.isLocked || scope.isCancelled)) {
                scope.send({person: scope.child});
            }
        };

        scope.isSendTripToReviewDisabled = function() {
            return !scope.child.IsCompleted
                || scope.isLocked
                || scope.isCancelled;
        };

        const emptyChild = travellerUtils.processTraveller({
            Id: scope.child.Id,
            HasMultiplePassports: false,
            PassengerType: scope.child.PassengerType,
        }, scope.model.Travelers, scope.child.positionIndex);

        /**
         * Edited information about travellers
         * User can change information and click after the on 'Clear details' button
         * and we have to restore the edited information about the travellers, so we need to have separate object
         */
        scope.editedChild = angular.copy(scope.child);
        scope.editedChild.birthDayOpen = false;
        scope.editedChild.expireDateOpen = false;
        scope.getToggleDropDown = function(dropdownKey = 'birthDayOpen') {
            scope.editedChild[dropdownKey] = false;
        };
        travellerUtils.addTravellerAdditionalFields(scope.editedChild, scope.model.Travelers);

        // TODO: Is it needed? Refactor?
        scope.isMobile = (deviceDetector.device === 'iphone' || deviceDetector.device === 'android');

        scope.isActive = scope.model.IsEditable;

        scope.isFlightPresent = scope.model.IsFlightTripItemExist;

        scope.isUkRailPresent = scope.model.IsRailTripItemExist;

        scope.passportExpireDatepickerOptions = {
            min: moment(scope.model.TripLastDate).add({months: 6}),
        };

        scope.dateOfBirthDatepickerOptions = {
            min: moment(scope.model.MaximumChildDob).add({days: 1}),
            max: moment(scope.model.MaximumInfantDob),
        };

        scope.collapseTravellerForm = function(traveller) {
            traveller.isOpenedForm = !traveller.isOpenedForm;
        };

        scope.getFullName = travellerUtils.getTravellerFullName;

        scope.saveChildTraveller = function(child, editedChild) {
            scope.isDuplicateError = !!travellerUtils.findTravellerNameDuplication(editedChild, scope.model.Travelers);

            if (scope.isDuplicateError) {
                return;
            }

            saveChildTraveller();

            function saveChildTraveller() {
                if (!editedChild.TripPassengerId) {
                    editedChild.TripPassengerId = editedChild.Id;
                }

                travellerUtils.saveTraveller(editedChild, scope.model.Id, scope.isFlightPresent, scope.isUkRailPresent, child.positionIndex)

                    .then((response) => {
                        editedChild.TripPassengerId = editedChild.Id = response.data.TripPassengerId;
                        _.extend(child, editedChild, {
                            IsCompleted: true,
                            isOpenedForm: false,
                        }, function(value, other) {
                            if (other === '') {
                                return null;
                            }
                            if (_.isObject(other)) {
                                return angular.copy(other);
                            }
                            return other;
                        });

                        /**
                         * Update Trip details after Travellers adding
                         */
                        scope.$emit(tripEvents.TRIP_DETAILS_UPDATE);
                    })
                    .catch(() => {
                        child.IsCompleted = false;
                    });
            }
        };
        scope.restoreData = function(restoreFormState) {
            if (restoreFormState) {
                angular.copy(scope.child, scope.editedChild);
            } else {
                angular.copy(emptyChild, scope.editedChild);
            }
            scope.child.isOpenedForm = !restoreFormState;
        };

        scope.ApisHasLevel = function(level) {
            return tripFactory.apisHasLevel(level, scope.model.ApisTsaSettings);
        };
        scope.edit = function() {

            /**
             * Redirect to login page if anonymus clicked on the link
             */
            if ($rootScope.readOnlyMode) {
                $state.go('login');
            }
            scope.child.isOpenedForm = !scope.child.isOpenedForm;
        };
    }

    function isSendDocumentationOptionVisible() {
        return !!$scope.child.IsCompleted
            && !$scope.model.IsOfflineTrip
            && !$scope.model.IsRailsOnly;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/childTraveller.directive.js